import { PureComponent } from "react";
import OnePagerWithImageContentComponent from "components/templates/one-pager-with-image-template/one-pager-with-image-content/one-pager-with-image-content-component";
import { StyledOnePagerWithImageComponent } from "./one-pager-with-image-component.scss";

export default class OnePagerWithImageComponent extends PureComponent {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <StyledOnePagerWithImageComponent className="one-pager-with-image-component">
        <OnePagerWithImageContentComponent {...this.props} />
      </StyledOnePagerWithImageComponent>
    );
  }
}

OnePagerWithImageComponent.defaultProps = {
  imageWithBackgroundPart: {
    backgroundColor: "brand-blue",
    src: "/static/img/boards/board-with-pencils.png",
    alt: "",
    imageSegmentHeight: "100vh"
  },
  textPart: {
    titleLines: ["Project Management", "<b>is better when it's visual</b>"],
    subtitleLines: ["See what everyone on your team is working on in a single glance"],
    bullets: [
      "Manage your projects & tasks with ease",
      "Plan visually on a timeline",
      "Centralize communication in one place"
    ],
    mobileTitleLines: ["Project Management", "<b>is better when it's visual</b>"],
    mobileSubtitleLines: ["See what everyone on your team", "is working on in a single glance"],
    color: "black"
  },
  signupForm: {
    buttonColor: "brand-pink",
    buttonText: "Get Started",
    inputPlaceholder: "Enter your work email",
    downloadButtonTitle: "Download The App"
  }
};
